import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';

import {
  InputAdornment,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  ListItemAvatar,
  Avatar,
  IconButton,
  Snackbar,
  TextField,
} from '@material-ui/core';

import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import { MAX_NOTE_CHARS } from '../../constants/general';
import { formatEmployeeDisplayName } from '../../helpers/helpers';

import '../../assets/stylesheets/Notes.css';
import i18n from '../../i18n';

class Note extends Component {
  constructor(props) {
    super(props);
    const { note } = this.props;
    const { description } = note;

    const charsRemaining = (description && description.length)
      ? MAX_NOTE_CHARS - description.length
      : MAX_NOTE_CHARS;

    this.state = {
      inEditMode: false,
      description,
      charsRemaining,
      error: false,
      snackMessage: '',
      snackOpen: false,
    };
    this.baseState = description;
  }

  toggleEditMode = () => {
    this.setState(prevState => ({ inEditMode: !prevState.inEditMode }));
  };

  cancelChanges = () => {
    this.setState({ description: this.baseState, inEditMode: false });
  };

  hideSnackbar = () => {
    this.setState({ snackOpen: false });
  }

  onChangeNoteDescription = event => {
    const charsRemaining = MAX_NOTE_CHARS - event.target.value.length;
    const error = charsRemaining < 0;
    this.setState({ description: event.target.value, charsRemaining, error });
  };

  onSaveNoteDescription = () => {
    const { description, error } = this.state;
    const { note, updateNoteDescription } = this.props;
    if (error) {
      this.setState({
        snackMessage: i18n.t('userProfile:noteLengthError'),
        snackOpen: true,
      });
    } else {
      updateNoteDescription(note.id, description);
      this.setState({ inEditMode: false });
    }
  };

  render() {
    const {
      charsRemaining,
      error,
      inEditMode,
      snackMessage,
      snackOpen,
    } = this.state;
    const { note, isEditable, onDelete, isLoggedInUserNote } = this.props;
    const employeeDisplayName = formatEmployeeDisplayName(
      note.authorStudioEmployee.firstName,
      note.authorStudioEmployee.lastName,
      note.authorStudioEmployee.nickName
    );
    return (
      <>
        <ListItem
          alignItems="flex-start"
          className={`note-block ${isLoggedInUserNote ? 'ssensePrimary' : ''}`}
        >
          <ListItemAvatar>
            <Avatar
              alt={employeeDisplayName}
              src={note.authorStudioEmployee.profileImage}
            />
          </ListItemAvatar>

          <ListItemText
            className={isEditable ? 'editableNoteItemText' : ''}
            disableTypography
            primary={
              <>
                <span className="noteAuthor">
                  {employeeDisplayName}
                </span>
                <span className="noteDate">
                  {format(new Date(note.updatedAt), 'MMM d, yyyy')}
                </span>
                <br />
              </>
            }
            secondary={
              inEditMode ? (
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  multiline
                  error={error}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">{charsRemaining}</InputAdornment>
                  }}
                  className="noteEditField"
                  defaultValue={note.description}
                  onChange={this.onChangeNoteDescription}
                />
              ) : (
                <span className={isEditable ? 'editableNoteDescription' : ''}>
                  {note.description}
                </span>
              )
            }
          />
          {isEditable && (
            <ListItemSecondaryAction>
              {inEditMode ? (
                <>
                  <IconButton
                    edge="end"
                    aria-label="save"
                    onClick={this.onSaveNoteDescription}
                  >
                    <SaveIcon color="secondary" />
                  </IconButton>
                  <IconButton
                    edge="end"
                    aria-label="cancel"
                    onClick={this.cancelChanges}
                  >
                    <ClearOutlinedIcon color="secondary" />
                  </IconButton>
                </>
              ) : (
                <>
                  <IconButton
                    edge="end"
                    aria-label="edit"
                    onClick={this.toggleEditMode}
                  >
                    <EditIcon color="secondary" />
                  </IconButton>
                  <IconButton
                    edge="end"
                    aria-label="delete"
                    onClick={() => onDelete(note.id)}
                  >
                    <DeleteIcon color="secondary" />
                  </IconButton>
                </>
              )}
            </ListItemSecondaryAction>
          )}
        </ListItem>
        <Snackbar
          message={snackMessage}
          open={snackOpen}
          onClose={this.hideSnackbar}
          autoHideDuration={2000}
        />
      </>
    );
  }
}

Note.propTypes = {
  isEditable: PropTypes.bool.isRequired,
  isLoggedInUserNote: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  updateNoteDescription: PropTypes.func.isRequired,
  note: PropTypes.shape({
    id: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    description: PropTypes.string,
    profileImage: PropTypes.string,
    authorStudioEmployee: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      nickName: PropTypes.string,
      profileImage: PropTypes.string,
    })
  }).isRequired,
};

export default Note;
